export default "__VITE_ASSET__t8WGg3tz__"